import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Invoice from './Components/Invoice/Invoice';
import Navbar from './Components/Navbar/Navbar';
import { BrowserRouter as Router,Routes,Route } from 'react-router-dom';
import Quotation from './Components/Quotation/Quotation';
import Payslip from './Components/Payslip/Payslip';
import Home from './Components/Home/Home';
import PrivacyPolicy from './Components/PrivacyPolicy/PrivacyPolicy';
import TermsAndConditions from './Components/Terms_And_Conditions/TermsAndConditions';

function App() {

  return (
    <div className='universal_background'>
      <Router>
        <Routes>
          {/* Parent Route for Navbar */}
          <Route path="/" element={<Navbar />}>
            {/* Child Route for Invoice */}
            <Route path="/" element={<Home />} />
            <Route path="/invoice-generator" element={<Invoice />} />
            <Route path="/quotation-generator" element={<Quotation />} />
            <Route path="/payslip-generator" element={<Payslip />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
          </Route>
        </Routes>
      </Router>
    </div>
  );
}

export default App;
